'use strict';
import angular from 'angular';

angular.module('common.ctrls', [])
    .controller('SampleController', SampleController)

SampleController.$inject = ['$rootScope', '$scope', '$stateParams', '$state', '$ioAlert'];
function SampleController($rs, $scope, $stateParams, $state, $ioAlert){

};